import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterSupplyDistributionNetworkTableDataAPI = createAsyncThunk("WaterSupplyDistributionNetworkTableData", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        ReadingDate,
        token,
        FromTop,
        ToTop,
        M_WardID,
        M_UserID,
        handleDistributionNetworkExport
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WS_WaterNetworkSupply_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID}&M_Distri_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleDistributionNetworkExport && handleDistributionNetworkExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyDistributionNetworkTableDataSlice = createSlice({
    name: "WaterSupplyDistributionNetworkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyDistributionNetworkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyDistributionNetworkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyDistributionNetworkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyDistributionNetworkTableDataReducer = WaterSupplyDistributionNetworkTableDataSlice.reducer


export const WaterSupplyDistributionNetworkTableExportDataAPI = createAsyncThunk("WaterSupplyDistributionNetworkTableExportData", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        ReadingDate,
        token,
        FromTop,
        ToTop,
        M_WardID,
        M_UserID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WS_WaterNetworkSupply_Select?ReadingDate=${ReadingDate}&M_WardID=${M_WardID}&M_Distri_WS_LocationID=${M_Distri_WS_LocationID ? M_Distri_WS_LocationID : '0'}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyDistributionNetworkTableExportDataSlice = createSlice({
    name: "WaterSupplyDistributionNetworkTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyDistributionNetworkTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterSupplyDistributionNetworkTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterSupplyDistributionNetworkTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyDistributionNetworkTableExportDataReducer = WaterSupplyDistributionNetworkTableExportDataSlice.reducer


// InsertUpdate Table Data

export const WaterSupplyDistributionNetworkPostDataAPI = createAsyncThunk("WaterSupplyDistributionNetworkPostData", async ({ data }) => {
    const {
        T_Distri_WS_WaterNetworkSupplyID,
        ConsumptionMetered,
        ConsumptionUnMetered,
        StipulatedMorning,
        StipulatedEvening,
        ActualMorning,
        ActualEvening,
        CriticalPointsRequired,
        CriticalPointsActual,
        CriticalPointsNormal,
        CriticalPointsAffected,
        M_WardID,
        PumpStation,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        // handleClearField,
        handleOnCloseClick

    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_Distri_WS_WaterNetworkSupplyID", T_Distri_WS_WaterNetworkSupplyID);
    formdata.append("ConsumptionMetered",ConsumptionMetered);
    formdata.append("ConsumptionUnMetered", ConsumptionUnMetered);
    formdata.append("StipulatedMorning", StipulatedMorning);
    formdata.append("StipulatedEvening", StipulatedEvening);
    formdata.append("ActualMorning", ActualMorning);
    formdata.append("ActualEvening", ActualEvening);
    formdata.append("CriticalPointsRequired", CriticalPointsRequired);
    formdata.append("CriticalPointsActual", CriticalPointsActual);
    formdata.append("CriticalPointsNormal", CriticalPointsNormal);
    formdata.append("CriticalPointsAffected", CriticalPointsAffected);
    formdata.append("M_UserID",M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WS_WaterNetworkSupply_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WaterSupplyDistributionNetworkPostDataSlice = createSlice({
    name: "WaterSupplyDistributionNetworkPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyDistributionNetworkPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(WaterSupplyDistributionNetworkPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyDistributionNetworkPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyDistributionNetworkPostDataReducer = WaterSupplyDistributionNetworkPostDataSlice.reducer



// // Delete Table Data

export const WaterSupplyDistributionNetworkDeleteAPI = createAsyncThunk("WaterSupplyDistributionNetworkDelete", async ({ data }) => {

    const {
        T_Distri_WS_WaterNetworkSupplyID,
        M_UserID,
        handleIsPost,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_Distri_WS_WaterNetworkSupplyID", T_Distri_WS_WaterNetworkSupplyID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WS_WaterNetworkSupply_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WaterSupplyDistributionNetworkDeleteSlice = createSlice({
    name: "WaterSupplyDistributionNetworkDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyDistributionNetworkDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterSupplyDistributionNetworkDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WaterSupplyDistributionNetworkDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyDistributionNetworkDeleteReducer = WaterSupplyDistributionNetworkDeleteSlice.reducer